<template>
    <div>
        <div
            class="d-flex"
        >
            <div
                class="flex-shrink-1 pr-2"
            >
                <b-img
                    src="/img/Wikipedia_affiliative_mark.png"
                    class="d-block"
                    style="width: 3.2rem;"
                />
            </div>
            <div
                class="w-100 pt-2"    
            >
                Artikel in der:
            </div>
        </div>
        <div
            class=""
        >
            <b-link
                tag="a"
                v-for="(article, index) in articles"
                :key="index"
                :href="article.article"
                target="_blank"
                class="d-block"
            >
                &rarr; {{ article.anchorText }} Wikipedia
            </b-link>
        </div>
    </div>
</template>
<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
// import axios from 'axios'

export default {
  name: 'wiki-image',
  props: {
      articles: Array
  },
  components: {
     
  },
  data () {
      return {
        
      }
  },
  methods: {
    ...mapActions({
        
    }),
    fetchData () {
        
    }
  },
  computed: {
    ...mapGetters({
      
    })
  },
  created () {
    this.fetchData()
  }
}
</script>
<style scoped>

</style>
